export const ZDQ_DESTINATION_DATA = 'Zdq/destinationData';
export const ZDQ_RECIPIENT = 'Zdq/recipient';